<template src="./template.html"></template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { directive as onClickaway } from 'vue-clickaway';
import GlobalSearch from '@/components/global/globalSearch/index.vue'
import MainLogo from '@/components/elements/mainLogo.vue'
import Menu from '../menu/index.vue'
import LinkMenu from "@/components/global/linkMenu/index.vue";
import NotificationsMenu from "@/components/global/notifications/index.vue";

export default {
  name: 'Header',
  directives: {
    onClickaway: onClickaway,
  },
  components: {
    LinkMenu,
    Menu,
    MainLogo,
    GlobalSearch,
    NotificationsMenu
  },
  data() {
    return {
      navTitle: 'I am navigation from data',
      opened: false,
      search: '',
      mobileMenuOpened: false,
      // hasManySubaccounts: false
    };
  },
  created() {
    // this.hasManySubaccounts = this.get_user.accessible_subaccounts_array.length > 1
  },
  computed: {
    ...mapGetters(['get_user', 'get_subaccounts', 'get_active_subaccount']),
    subAccountList() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1);
    },
    hasManySubaccounts() {
      return this.get_user.accessible_subaccounts_array.length > 1 ? true : false;
    },
    filteredList() {
      if(this.subAccountList.length < 1) return [];
      return this.subAccountList.filter(option => {
        return option.name.toLowerCase().includes(this.search.toLowerCase()) || option.billing_company_name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    closeMenu() {
      this.opened = false;
      this.search = '';
    },
    openMenu() {
      this.opened = !this.opened;
      let self = this;
      setTimeout(() => {
        if(self.opened) {
          self.$refs.searchInput.focus();
        }
      }, 100)
    },
    toggleMobileMenu() {
      //console.log('working')
      this.mobileMenuOpened = !this.mobileMenuOpened
    },
    // Here we are updating logged user active subaccount
    setActiveSubaccount(subaccount) {
      this.$store.dispatch('STORE_ACTIVE_SUBACCOUNT', subaccount);
      this.$store.dispatch(`EDIT_USER`, {
        form: { ...this.get_user, active_subaccount_id: subaccount.id},
        id: this.get_user.id,
      }).then(() => {
        //this.$store.dispatch('GET_USER', {id: this.get_user.id});
        this.$store.dispatch('GET_PROFILE').then((profileRes) => {
          this.$store.dispatch('STORE_USER', profileRes).then(() => {
            //console.log('RUTA: ', this.$route)
            if(this.$route.name !== 'book-shipment'){
              location.reload();
            }
          });
        })
      });
      this.opened = false;
    },
  },
};
</script>
